import config from "../../app.json";
import axios from "axios";

import "react-toggle/style.css";
import "./notifications.scss";
import Toggle from "react-toggle";
import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import FieldCheckbox from "../Fields/FieldCheckbox";
import AlertComponent from "../AlertComponent";

import PlusIcon from "../../Assets/Images/plus.svg";

function Notifications() {
  const [notifications, setNotifications] = useState(false);
  const [platformNewNotifications, setPlatformNewNotifications] = useState(false);

  const [teamNewNotifications, setTeamNewNotifications] = useState(false);
  const [teamInviteChat, setTeamInviteChat] = useState(false);
  const [teamMentioned, setTeamMentioned] = useState(false);

  const [appMentioned, setAppMentioned] = useState(false);

  const handleSubmit = () => {
    AlertComponent("Success", "Notifications preferences has been saved (Mocked message)");
  };
  const handleNotifications = () => {
    setNotifications(!notifications);
  };
  return (
    <div>
      <div className="notifications-container">
        <div className="notifications-column">
          <h2>Notifications</h2>
        </div>
        <div className="notifications-column">
          <div className="form-group">
            <div className="recurrency">
              <Toggle checked={notifications} onClick={handleNotifications} className="form-group" />
            </div>
          </div>
        </div>
      </div>

      <div className={`notifications-section ${notifications ? `` : `notifications-disabled`}`}>
        <h5>SocialChimp Platform</h5>
        <FieldCheckbox
          label={`New Notifications`}
          onChange={setPlatformNewNotifications}
          checked={platformNewNotifications}
          classNames={`notifications-container`}
          classNamesLabel={`notifications-column`}
        />
      </div>

      <div className={`notifications-section ${notifications ? `` : `notifications-disabled`}`}>
        <h5>From team</h5>
        <FieldCheckbox
          label={`New Notifications`}
          onChange={setTeamNewNotifications}
          checked={teamNewNotifications}
          classNames={`notifications-container`}
          classNamesLabel={`notifications-column`}
        />
        <FieldCheckbox
          label={`Someone invite you to new chat`}
          onChange={setTeamInviteChat}
          checked={teamInviteChat}
          classNames={`notifications-container`}
          classNamesLabel={`notifications-column`}
        />
        <FieldCheckbox label={`Mentioned`} onChange={setTeamMentioned} checked={teamMentioned} classNames={`notifications-container`} classNamesLabel={`notifications-column`} />
      </div>

      <div className={`notifications-section ${notifications ? `` : `notifications-disabled`}`}>
        <h5>From SocialChimp app</h5>
        <FieldCheckbox label={`Mentioned`} onChange={setAppMentioned} checked={appMentioned} classNames={`notifications-container`} classNamesLabel={`notifications-column`} />
      </div>

      <Button onClick={handleSubmit}>Save</Button>
    </div>
  );
}

export default Notifications;
